import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    label: string;
    selectLocation: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the upload location selection button */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadLocationRow.label?c=ca809et51pm2", defaultMessage: "Upload Location" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the upload location selection button when no location is selected */
            selectLocation: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadLocationRow.selectLocation?c=2ddzt6oahr6db", defaultMessage: "Select a Frame.io Location" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
